import React from 'react';
import cx from 'classnames';

import styles from './CheckList.module.scss';

import { CheckListProps, Checkmark } from './CheckList.types';

export const CheckList: React.FC<CheckListProps> = ({
  className,
  items,
  checkmark = Checkmark.Green,
  useHtml = false,
}) => {
  return (
    <ul className={`${styles.checkList} ${className}`}>
      {items.map((item) => (
        <li
          key={`list-item-${item}`}
          className={cx(styles.checkList__item, styles[checkmark])}
          data-cy={`list-item-${item}`}
        >
          {useHtml ? <span dangerouslySetInnerHTML={{ __html: item }}></span> : item}
        </li>
      ))}
    </ul>
  );
};
